import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=a0636e5a&scoped=true&"
import script from "./ServiceItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=a0636e5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0636e5a",
  null
  
)

export default component.exports